//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { pageCreate, packageChatSpecific } from "@/api/create";
import Afooter from '@/components/Afooter'
export default {
  name: 'create',
  components: {
    Afooter,
  },
  data: function () {
    return {
      activeTitle: 0,
      title: '发现',
      bannerH: 0,
      top: 0,
      bottom: 0,
      contentH: 0,
      systemType: '',
      dataList: [],
      expertList: [],
      isIphone: false
    }
  },
  created () {
    this.getData()
  },
  activated() {
    // this.getData()
  },
  mounted () {
    if (navigator.userAgent.includes('AppleWebKit')) {
      this.isIphone = true
    }
  },
  methods: {
    toChatList () {
      this.$router.push({
        path: '/mychat'
      })
    },
    getData () {
      pageCreate().then(res => {
        console.log(res)
        this.dataList = res.data
        localStorage.setItem('create', JSON.stringify(this.dataList))
      })
    },
    goArticle () {
      this.$router.push({
        path: '/article'
      })
    },
    goSubscribe () {
      this.$router.push({
        path: "/subscribe",
      });
    },
    goChat (type) {
      this.$router.push({
        path: '/chat?type=' + encodeURIComponent(type)
      })
    },
    toDetail (item) {
      localStorage.setItem('create-detail', JSON.stringify(item))
      this.$router.push({
        path: '/createDetail?title=' + encodeURIComponent(item.type)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Create/create.vue